import UserConfig from "./UserConfig";
import AuthService from "../auth/AuthService";
export default class UserService {
  /******* USERS **********/
  static getUsers(app, filter, order, limit) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointUsers;
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({filter:filter,order:order,limit:limit})
        });
        // console.log("getUsers", response, app)
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static getUsersByReg(app, filter) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = `${UserConfig.endpointUsersByReg}?filter=${filter}`;
        let response = await UserConfig.APIConnector.get(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
        });
        // console.log("getUsers", response, app)
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static getUsersByEmailOrDU(app, usersDU, usersEmail) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointUsersByEmailOrDU;
        console.log("getUsersByEmailOrDU 1", usersDU, usersEmail);
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ usersDU: usersDU, usersEmail: usersEmail }),
        });
        console.log("getUsersByEmailOrDU 2", response, app);
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        console.log("ERROR", e);
        reject(e);
      }
    });
  }

  static getUserById(app, userId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointUserById;
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ userId: userId}),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        console.log("ERROR", e);
        reject(e);
      }
    });
  }
  static getUsersFromStorage(path, filename) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointUsersFromStorage;
        console.log("getUsersFromStorage ", path, filename);
        let response = await UserConfig.APIConnectorLarge.post(endpoint, {
          headers: { Authorization: "Bearer " + token },
          body: JSON.stringify({ path: path, filename: filename }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static saveUser(app, user) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointSaveUser;
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify(user),
        });
        // console.log("RESPONSE SAVE USER",response)
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static deleteUser(app, userId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointDeleteUser;
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ id: userId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  static transferPoints(app, points, dni) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.transferPointEndpoint.concat(
          `?document=${dni}`
        );
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            points: points,
            description: "Recarga de puntos",
          }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static addTagsToUsers(app, tags, allUsersSelected, users) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointAddTagToUser;
        console.log("ADD TAG TO USERS", endpoint, { tags: tags, allUsersSelected:allUsersSelected, users: users });
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ tags: tags, allUsersSelected:allUsersSelected,  users: users }),
        });
        console.log("RESPONSE SAVE USER", response);
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static sendNotification(app, user, notification) {
    console.log(" >>>>>>>>>> user", user);
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointSendNotification;
        let response = await UserConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            userToken: user.FCMToken,
            notification: notification,
            id: user.id,
          }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static movementsLoyalty(app,user){
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = UserConfig.endpointMovementsLoyalty;
        let response = await UserConfig.APIConnector.get(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app, user_id:user.id }
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  /******** FIN USERS *********/
}



// WEBPACK FOOTER //
// ./src/provider/user/UserService.js